var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 5.25V2.25H9C12.7275 2.25 15.75 5.2725 15.75 9C15.75 12.7275 12.7275 15.75 9 15.75C5.265 15.75 2.25 12.7275 2.25 9C2.25 6.7875 3.315 4.8375 4.9575 3.6075V3.5925L10.0575 8.6925L9 9.75L4.935 5.685C4.1925 6.585 3.75 7.74 3.75 9C3.75 11.9025 6.0975 14.25 9 14.25C11.9025 14.25 14.25 11.9025 14.25 9C14.25 6.3525 12.2925 4.1775 9.75 3.81V5.25H8.25ZM9 13.5C8.5875 13.5 8.25 13.1625 8.25 12.75C8.25 12.3375 8.5875 12 9 12C9.4125 12 9.75 12.3375 9.75 12.75C9.75 13.1625 9.4125 13.5 9 13.5ZM13.5 9C13.5 8.5875 13.1625 8.25 12.75 8.25C12.3375 8.25 12 8.5875 12 9C12 9.4125 12.3375 9.75 12.75 9.75C13.1625 9.75 13.5 9.4125 13.5 9ZM5.25 9.75C4.8375 9.75 4.5 9.4125 4.5 9C4.5 8.5875 4.8375 8.25 5.25 8.25C5.6625 8.25 6 8.5875 6 9C6 9.4125 5.6625 9.75 5.25 9.75Z",
    fill: "#0075C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerDot);
export default __webpack_public_path__ + "static/media/timerDot.dfc90d221deda71577a533ede12c7cfd.svg";
export { ForwardRef as ReactComponent };